var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipseOutside({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1359,
    height: 1117,
    viewBox: "0 0 1359 1117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0489 684C80.4838 1223.87 539.201 1643 1095.81 1643C1695.04 1643 2180.81 1157.23 2180.81 558C2180.81 -41.2289 1695.04 -527 1095.81 -527C528.932 -527 63.5919 -92.2632 15 462",
    stroke: "#E8E8E8",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseOutside);
export default __webpack_public_path__ + "static/media/ellipse-outside.8064d88934da4b41922cdf28bef374ca.svg";
export { ForwardRef as ReactComponent };